import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "width-100 survey-head-container" }
const _hoisted_2 = {
  class: "inline-flex survey-details width-100 align-center justify-space-between",
  "aria-label": "Survey details Header"
}
const _hoisted_3 = { class: "survey-details-header" }
const _hoisted_4 = { class: "survey-details-nav" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", null, "View By:", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" All Strata ")
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", null, "Request Raw Data", -1)
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", null, "Download Summary Results", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CaretDownFilled = _resolveComponent("CaretDownFilled")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_TabPane = _resolveComponent("TabPane")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_SummaryDataModal = _resolveComponent("SummaryDataModal")!
  const _component_RequestRawDataModal = _resolveComponent("RequestRawDataModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.getName), 1),
      _createElementVNode("nav", _hoisted_4, [
        (_ctx.getSurveyType?.toLowerCase() === 'nns')
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_Dropdown, { class: "font-reg" }, {
                default: _withCtx(() => [
                  _createVNode(_component_Button, { size: "large" }, {
                    default: _withCtx(() => [
                      _hoisted_7,
                      _createVNode(_component_CaretDownFilled, { style: {"color":"black"} })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("span", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showRequestRawDataModal && _ctx.showRequestRawDataModal(...args)))
        }, [
          _createElementVNode("img", {
            src: require('../../../assets/svg/raw-data-check.svg'),
            alt: "raw data request icon"
          }, null, 8, _hoisted_8),
          _hoisted_9
        ]),
        _createElementVNode("span", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSummaryClick && _ctx.onSummaryClick(...args)))
        }, [
          _createElementVNode("img", {
            src: require('../../../assets/svg/download-sum.svg'),
            alt: "download summary results icon"
          }, null, 8, _hoisted_10),
          _hoisted_11
        ])
      ])
    ]),
    _createVNode(_component_Tabs, {
      activeKey: _ctx.active,
      "onUpdate:activeKey": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.active) = $event)),
      type: "card",
      size: "large",
      class: "survey-tabs",
      tabBarGutter: "0.5rem",
      tabBarStyle: {backgroundColor:'#f4f4f5'},
      onChange: _ctx.activeTabs
    }, {
      default: _withCtx(() => [
        _createVNode(_component_TabPane, {
          tab: "SURVEY METADATA",
          key: "SurveyMetadata"
        }),
        _createVNode(_component_TabPane, {
          tab: "RESULTS",
          key: "SurveyResults"
        }),
        _createVNode(_component_TabPane, {
          tab: "REPORTS",
          key: "SurveyReports"
        })
      ]),
      _: 1
    }, 8, ["activeKey", "onChange"]),
    _createVNode(_component_SummaryDataModal, {
      selectedSurveys: [_ctx.getId],
      ref: "surveySummaryData"
    }, null, 8, ["selectedSurveys"]),
    _createVNode(_component_RequestRawDataModal, {
      selectedSurveys: _ctx.selectedSurveys,
      ref: "rawDataModal"
    }, null, 8, ["selectedSurveys"])
  ]))
}